module.exports = __webpack_public_path__ + "img/discount18.9b19d4d0.png";